import { Pipe, PipeTransform } from '@angular/core';
import {MasterInputInstructionModel, MasterOutputInstructionModel} from "web-shared";
import {MasterUseInstructionModel} from "web-shared";

@Pipe({
  name: 'isAlternative'
})
export class IsAlternativePipe implements PipeTransform {

  transform(value: MasterInputInstructionModel | MasterUseInstructionModel | MasterOutputInstructionModel, masterInstructions: MasterInputInstructionModel[] | MasterUseInstructionModel[] | MasterOutputInstructionModel[]): boolean {
    return (masterInstructions as MasterInputInstructionModel[]).filter(mi => mi.Code === value.Code && mi.ValidCondition?.Formula === value.ValidCondition?.Formula && mi.TaskSelectorId === value.TaskSelectorId).length > 1;
  }
}
